export default __webpack_public_path__ + "ffa679ac090dfee8083aedeab454b0d5.png";